<template>
  <smart-banner
    :bg-color="bgColor"
    direction="row-reverse"
    :has-kicker="true"
    kicker-color="#717D96"
    kicker-weight="700"
    kicker-align="center"
    title-color="#3b3b3b"
    title-size="h1"
    title-weight="400"
    title-align="center"
    text-color="#43515A"
    text-size="md"
    text-weight="400"
    text-align="center"
    :has-button="true"
    :has-image="false"
    :center-items="true"
    :reduce-width="reduceWidth"
    :has-video="false"
    :is-404="false"
    :has-decorator="hasDecorator"
  >
    <template #kicker>
      <slot name="octonary-kicker" />
    </template>
    <template #title>
      <slot name="octonary-title" />
    </template>
    <template #text>
      <slot name="octonary-text" />
    </template>
    <template #button>
      <slot name="octonary-buttons" />
    </template>
  </smart-banner>
</template>

<script>
import SmartBanner from './smart-banner.vue'

export default {
  name: 'smart-banner-octonary',
  components: {
    SmartBanner,
  },
  props: {
    hasDecorator: {
      type: Boolean,
    },
    bgColor: {
      type: String,
      default: '#FFFFFF',
    }
  },
  data() {
    return {
      reduceWidth: window.innerWidth < 1200,
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWidth)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateWidth)
  },
  methods: {
    updateWidth() {
      this.reduceWidth = window.innerWidth < 1200
    },
  },
}
</script>
